<template>
    <a href="https://www.patreon.com/c/thecradlemedia/membership" target="_blank">

        <div class="patreon-support-banner">
            <div class="banner-inner">
                <p class="banner-text">
                    We've hit one million monthly readers — even through
                    <strong>censorship, DDOS attacks, and war.</strong>
                    You've had access to everything:
                    <strong>30k+ articles, interviews, investigations, maps, infographics</strong>
                    all without a single paywall.
                </p>

                <p class="banner-text">
                    Now it's time to choose what kind of media survives:
                    <strong>corporate</strong>, or <strong>independent</strong>?
                    The Cradle needs to become
                    <strong>completely reader funded by December 2026</strong> – and we need only
                    <strong>5,000 Patrons</strong> to reach that goal.
                </p>

                <p class="banner-text">
                    If you believe in media that can't be bought, prove it. Just
                    <span class="price-link">$5 a month</span> makes you part of the reason The Cradle exists.
                </p>

                <p class="banner-text">
                    Become a patron and help us reach our
                    <strong>first 1,000-subscriber goal</strong> by the end of March 2026.
                </p>

                <div class="cta-section">
                    <p class="banner-text power-text">
                        Reader power is the only power that matters.
                    </p>
                    <div class="icon-button-group" >
                        <img class="hand-icon" src="/assets/images/pointing-finger.svg" alt="Hand Icon">
                        <div class="patreon-button">
                            Join us on Patreon
                        </div>
                    </div>

                </div>
            </div>

            <div class="progress-section">
                <div class="progress-header">
                    <span class="progress-text">{{ currentPatrons.toLocaleString() }} of {{ patronGoal.toLocaleString() }} patrons</span>
                    <div class="progress-bar">
                        <div id="progress_fill" class="progress-fill" style="width: 43.2%"></div>
                    </div>
                    <img src="/assets/images/patreon.svg" alt="Patreon Logo" class="patreon-logo">
                </div>
            </div>
        </div>
    </a>

</template>

<script>
export default {
    name: 'PatreonSupportBanner',
    props: {
        currentPatrons: {
            type: Number,
            default: 432
        },
        patronGoal: {
            type: Number,
            default: 1000
        }
    },
    computed: {
        progressPercentage() {
            return (this.currentPatrons / this.patronGoal) * 100;
        }
    },
    mounted() {
        const progressFill = document.getElementById('progress_fill');
        if (progressFill) {
            progressFill.style.width = this.progressPercentage + '%';
        }
    }
}
</script>

<style scoped>
.patreon-support-banner {
    background-color: var(--cdl-primary);;
    border: 3px solid var(--cdl-primary);;
    border-radius: 12px;
    padding: 5px;
    margin: 40px 0;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    user-select: none;
}

.banner-inner {
    background-color: #d3d3d3;
    padding: 20px 20px;
    border-radius: 8px;
    margin-bottom: 20px;
}

.hand-icon {
    width: 24px;
    flex-shrink: 0;
}

.banner-text {
    color: #1a1a1a;
    font-size: 17px;
    line-height: 1.6;
    margin-bottom: 18px;
    font-family: Arial, sans-serif;
}

.banner-text:last-child {
    margin-bottom: 0;
}

.banner-text strong {
    font-weight: 700;
    color: #1a1a1a;
}

.price-link {
    color: var(--cdl-primary);;
    text-decoration: underline;
    font-weight: 700;
    transition: opacity 0.3s;
}

.price-link:hover {
    opacity: 0.8;
}

.cta-section {
    display: flex;
    align-items: center;
    gap: 15px;
    margin-top: 25px;
    flex-wrap: wrap;
}

.icon-button-group {
    display: flex;
    align-items: center;
    gap: 15px;
    flex-shrink: 0;
}

.power-text {
    margin: 0;
    flex-shrink: 0;
}

.patreon-button {
    background-color: #1a1a1a;
    color: #FFFFFF;
    padding: 12px 28px;
    border-radius: 6px;
    text-decoration: none;
    font-weight: 700;
    font-size: 16px;
    transition: background-color 0.3s;
    display: inline-block;
}

.patreon-button:hover {
    background-color: #2a2a2a;
    color: #FFFFFF;
}

.progress-section {
    background-color: #a40404;
    padding: 20px 30px;
    border-radius: 8px;
}

.progress-header {
    display: flex;
    align-items: center;
    gap: 20px;
}

.progress-text {
    color: #FFFFFF;
    font-size: 20px;
    font-weight: 700;
    white-space: nowrap;
    flex-shrink: 0;
}

.progress-bar {
    flex: 1;
    height: 28px;
    background-color: rgba(255, 255, 255, 0.3);
    border-radius: 14px;
    overflow: hidden;
    position: relative;
}

.progress-fill {
    height: 100%;
    background-color: #FFFFFF;
    border-radius: 14px;
    transition: width 0.5s ease;
}

.patreon-logo {
    flex-shrink: 0;
    height: 40px;
    width: auto;
    background-color: #000000;
    padding: 8px 12px;
    border-radius: 6px;
}

@media (max-width: 768px) {
    .hand-icon {
        width: 20px;
    }

    .patreon-support-banner {
        padding: 20px;
    }

    .banner-inner {
        padding: 25px;
    }

    .banner-text {
        font-size: 16px;
    }

    .cta-section {
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
    }

    .patreon-button {
        width: 100%;
        text-align: center;
    }

    .progress-section {
        padding: 15px 20px;
    }

    .progress-header {
        flex-wrap: wrap;
        gap: 10px;
    }

    .progress-text {
        font-size: 16px;
        width: 100%;
        text-align: center;
    }

    .progress-bar {
        order: 2;
    }

    .patreon-logo {
        order: 1;
        height: 24px;
        display: none;
    }
}

@media (max-width: 480px) {
    .patreon-support-banner {
        padding: 15px;
    }

    .banner-inner {
        padding: 20px;
    }

    .banner-text {
        font-size: 14px;
    }

    .progress-text {
        font-size: 14px;
    }

    .patreon-logo {
        height: 20px;
    }

    .patreon-button {
        padding: 8px 14px;
    }
}
</style>
